import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18 4C18 6.20914 13.9706 8 9 8C4.02944 8 0 6.20914 0 4C0 1.79086 4.02944 0 9 0C13.9706 0 18 1.79086 18 4ZM0 12C0 14.2 4 16 9 16C9.50993 16 10.0095 15.9813 10.4954 15.9453C10.1787 16.5613 10 17.2598 10 18C10 18.6983 10.159 19.3594 10.4429 19.9491C9.97349 19.9826 9.49158 20 9 20C4 20 0 18.2 0 16V12ZM9 10C4 10 0 8.2 0 6V10C0 12.2 4 14 9 14C14 14 18 12.2 18 10V6C18 8.2 14 10 9 10ZM21.5 17C22.8807 17 24 15.8807 24 14.5C24 13.1193 22.8807 12 21.5 12C20.1193 12 19 13.1193 19 14.5C19 14.5437 19.0011 14.5871 19.0033 14.6303L16.1022 16.0808C15.6684 15.7182 15.1097 15.5 14.5 15.5C13.1193 15.5 12 16.6193 12 18C12 19.3807 13.1193 20.5 14.5 20.5C15.1097 20.5 15.6684 20.2818 16.1022 19.9192L19.0033 21.3697C19.0011 21.4129 19 21.4563 19 21.5C19 22.8807 20.1193 24 21.5 24C22.8807 24 24 22.8807 24 21.5C24 20.1193 22.8807 19 21.5 19C20.8903 19 20.3316 19.2182 19.8978 19.5808L16.9967 18.1303C16.9989 18.0871 17 18.0437 17 18C17 17.9563 16.9989 17.9129 16.9967 17.8697L19.8978 16.4192C20.3316 16.7818 20.8903 17 21.5 17Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }